import {useQuery} from "@tanstack/react-query";
import {config} from "../config";
import apiClient from "./apiClient";
import {useAppContext} from "../libs/appContextLib";
import React from "react";

export function useFetchGtmStatsCustomConfig() {
    const {currUser} = useAppContext();
    const customerId = currUser?.customerId;
    const queryKey = React.useMemo(() => 
        [customerId ? `${customerId}_gtm-stats-custom-config` : 'gtm-stats-custom-config'], 
        [customerId]
    )
    return useQuery({
        queryKey,
        enabled: Boolean(customerId),
        queryFn: async () => {
            const response = await apiClient.get(`${config.REACT_APP_BACKEND_HOST}/gtm-stats-config`, {})
            return response.data
        },
        staleTime: 1000 * 60 * 5,  // 5 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
        refetchOnMount: false,
        refetchOnWindowFocus: false // Prevent refetch on window focus
    })
}
